export function calculateDateLastUpdate(date: string): number {
    if (date === '0001-01-01T00:00:00') {
        return null as any;
    }
    const hasZone = date.includes('Z');

    if (!hasZone) {
        date += 'Z';
    }

    const lastPositionTime: Date = new Date(date);
    const n = new Date();
    return Math.ceil((n.getTime() - lastPositionTime.getTime()) / 1000);
};
